import React from "react";
import { useParams } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";

const ProjectUniquePage = () => {
  const { projectListApi } = apiPath;
  const projectName = useParams();
  const [project, projectLoading] = useFetch(
    projectListApi,
    false,
    projectName.id
  );
  if (projectLoading) {
    return <Loading />;
  }

  const {
    image,
    projectTitle,
    projectLink,
    projectBannerImage,
    detailTitle,
    detailParagraph,
    clientName,
    category,
    date,
    social,
    role,
    thumbnail,
    images,
    dynamicDetail,
    problemSolvingDetail,
    challengesDetail,
    processDetails,
    projectStatus,
    visibility,
    conclusion,
  } = project;

  const roleData = [];

  if (role?.length > 0) {
    role.map((item, index) => {
      roleData.push({
        label: `Role ${index}`,
        type: "text",
        name: "",
        defaultValue: item,
      });
    });
  } else {
    [{}].map((item, index) => {
      roleData.push({
        label: `Role ${index}`,
        type: "text",
        name: "",
        defaultValue: "",
      });
    });
  }

  const dynamicDetailData = [];
  dynamicDetail.map((item, index) => {
    dynamicDetailData.push({
      label: `Detail ${index}`,
      type: "text",
      name: "",
      defaultValue: item,
    });
  });

  const dynamicDetailData2 = [];

  if (problemSolvingDetail?.length > 0) {
    problemSolvingDetail?.map((item, index) => {
      dynamicDetailData2.push({
        label: `Problem Solving Detail ${index}`,
        type: "text",
        name: "",
        defaultValue: item,
      });
    });
  } else {
    [{}]?.map((item, index) => {
      dynamicDetailData2.push({
        label: `Problem Solving Detail ${index}`,
        type: "text",
        name: "",
        defaultValue: "",
      });
    });
  }

  const imagesData = [];
  images?.map((item, index) => {
    imagesData.push({
      label: `Slider Image ${index}`,
      type: "file",
      name: "",
      defaultValue: item.image,
      required: false,
    });
  });

  const nestedData = [
    {
      elementType: "file",
      label: "Slider Image",
      name: "images",
      multipleData: imagesData,
      multiple: true,
      fullCol: true,
      required: false,
    },
  ];

  const data = [
    {
      elementType: "file",
      label: "Thumbnail Image",
      type: "file",
      name: "thumbnail",
      defaultValue: thumbnail,
      required: true,
    },
    {
      elementType: "file",
      label: "Banner Image",
      type: "file",
      name: "projectBannerImage",
      defaultValue: projectBannerImage,
      required: true,
    },
    {
      elementType: "file",
      label: "Project Brief Image",
      type: "file",
      name: "image",
      defaultValue: image,
      required: true,
    },
    {
      elementType: "input",
      label: "Project Title",
      type: "Text",
      name: "projectTitle",
      defaultValue: projectTitle,
      required: true,
    },
    {
      elementType: "input",
      label: "Project Link",
      type: "Text",
      name: "projectLink",
      defaultValue: projectLink,
      required: false,
    },
    {
      elementType: "input",
      label: "Project Brief Title",
      type: "Text",
      name: "detailTitle",
      defaultValue: detailTitle,
      required: true,
    },
    {
      elementType: "textField",
      label: "Project Brief Detail",
      type: "Text",
      name: "detailParagraph",
      defaultValue: detailParagraph,
      required: true,
    },
    {
      elementType: "input",
      label: "Client Name",
      type: "Text",
      name: "clientName",
      defaultValue: clientName,
      required: false,
    },
  ];
  const multiDimensionalData = [
    {
      elementType: "nested",
      label: "Role",
      name: "role",
      multipleData: roleData,
      multiple: true,
      required: false,
      noDropdown: true,
    },
  ];

  const moreData = [
    {
      elementType: "select",
      label: "Project Status",
      type: "Text",
      name: "projectStatus",
      required: false,
      defaultValue: projectStatus,
      options: ["ongoing", "completed"],
    },
    {
      elementType: "select",
      label: "Visibility",
      type: "Text",
      name: "visibility",
      required: false,
      defaultValue: visibility,
      options: ["show", "hide"],
    },
    {
      elementType: "input",
      label: "Date",
      type: "date",
      name: "date",
      defaultValue: date,
      required: false,
    },
    {
      elementType: "input",
      label: "Category",
      type: "Text",
      name: "category",
      defaultValue: category,
      required: true,
    },
    {
      elementType: "textField",
      label: "Challenges Paragraph",
      type: "Text",
      name: "challengesDetail",
      defaultValue: challengesDetail,
      required: false,
    },
  ];
  const midData = [
    {
      elementType: "textField",
      label: "Process Subheading",
      type: "Text",
      name: "processDetails",
      defaultValue: processDetails,
      required: false,
    },
  ];
  const multiDimensionalMultipleDataProject = [
    {
      elementType: "nestedMultiple",
      label: "Process Details",
      name: "dynamicDetail",
      multipleData: dynamicDetailData,
      multiple: true,
      required: false,
      // textAreaRequired: true,
      noImage: true,
    },
    {
      elementType: "nestedMultiple",
      label: "Problem Solving Details",
      name: "problemSolvingDetail",
      multipleData: dynamicDetailData2,
      multiple: true,
      required: false,
      // textAreaRequired: true,
      noImage: true,
    },
  ];

  const endData = [
    {
      elementType: "textField",
      label: "Conclusion",
      type: "Text",
      name: "conclusion",
      defaultValue: conclusion,
      required: false,
      fullCol: true,
    },
  ];

  const useData = data.concat(
    multiDimensionalData,
    moreData,
    nestedData,
    midData,
    multiDimensionalMultipleDataProject,
    endData
  );

  const update = (data) => {
    const filteredRoleArray = data.role
      .map((item) => item.filter((item) => item))
      .map((item) => item[0]);
    data.role = filteredRoleArray;
    const newImgArray = data?.images?.map((item) => {
      const newObj = {};
      newObj.image = item;
      return newObj;
    });
    data.images = newImgArray;
    updateData(`${projectListApi}/${projectName.id}`, data);
  };

  return (
    <div>
      <GlobalForm
        data={useData}
        nestedData={nestedData}
        multiDimensionalData={multiDimensionalData}
        multiDimensionalMultipleDataProject={
          multiDimensionalMultipleDataProject
        }
        update={update}
      />
    </div>
  );
};

export default ProjectUniquePage;
